export enum ThumbnailType {
  Lesson = 'lesson',
  Video = 'video',
  Files = 'files',
  File = 'file',
  LessonSlideScroll = 'lesson_slide_scroll',
  Contents = 'contents',
  Items = 'items'
}
